import React from "react";

export const CheckMarkIcon = (props) => {
  return (
    <svg
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="white"
      {...props}
    >
      <path
        d="M21 1.5L7.25 15.25L1 9"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
